var IntersectionTrackerTagMap = [
    ['article', 'article'],
    ['aside', 'aside'],
    ['div', 'div'],
    ['span', 'span'],
    ['footer', 'footer'],
    ['header', 'header'],
    ['section', 'section'],
    ['ul', 'ul'],
    ['ol', 'ol'],
    ['li', 'li']
];
export var IntersectionTrackerTags = new Map(IntersectionTrackerTagMap);
//# sourceMappingURL=types.js.map